import { render, staticRenderFns } from "./ImageChooser.vue?vue&type=template&id=3ab0acc4&scoped=true&"
import script from "./ImageChooser.vue?vue&type=script&lang=js&"
export * from "./ImageChooser.vue?vue&type=script&lang=js&"
import style0 from "./ImageChooser.vue?vue&type=style&index=0&id=3ab0acc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab0acc4",
  null
  
)

export default component.exports